/* ============================================================
   Nordstealth — Sendungsverfolgung.

   Fragt den eigenen Endpunkt ab und baut daraus das Ergebnis. Der
   Datenvertrag steht in _masterplan/07 Abschnitt 4; dieselben Daten
   liegen als worker/test/fixtures/*.json und dienen hier als
   Vorschau. Ein Vertrag, zwei Nutzer.

   Hausstil wie assets/ns-cart.js:
     ES5 (var, function, .then/.catch/.finally), IIFE, 'use strict',
     frueher Ausstieg wenn die Wurzel fehlt, eine einfache Sperre
     statt AbortController, Ringpuffer window.__nsSendung fuer die
     Pruefwerkzeuge.

   Vier Dinge, die nicht verhandelbar sind:

     1. Die E-Mail geht NIE in die Adresszeile, nie in localStorage,
        nie in den dataLayer.
     2. Kein technischer Fehler erreicht den Kunden. Jede Stoerung
        wird zu einem Satz in seiner Sprache.
     3. Auf myshopify-Hosts haengt _fd=0 an jede Anfrage, sonst
        leitet Shopify um und der Browser blockt die Antwort als
        fremde Herkunft. Ohne das scheitert jeder Prueflauf.
     4. Alle Texte aus der Antwort werden maskiert. Die
        Ereignistexte kommen vom Dienstleister, nicht von uns.
   ============================================================ */
(function () {
  'use strict';

  var wurzel = document.querySelector('.ns-sv');
  if (!wurzel) return;

  var spur = (window.__nsSendung = { version: 1, schritte: [], zustand: 'leer' });
  function log(x) {
    spur.schritte.push(x);
    if (spur.schritte.length > 30) spur.schritte.shift();
  }

  var form = wurzel.querySelector('.ns-sv__form');
  var feldNr = wurzel.querySelector('input[name="nr"]');
  var feldMail = wurzel.querySelector('input[name="mail"]');
  var knopf = wurzel.querySelector('.ns-sv__btn');
  var knopfText = wurzel.querySelector('.ns-sv__btn-text');
  var fehlerZeile = wurzel.querySelector('.ns-sv__fehler');
  var skelett = wurzel.querySelector('.ns-sv__skelett');
  var ergebnis = wurzel.querySelector('.ns-sv__ergebnis');
  var melder = wurzel.querySelector('.ns-sv__melder');
  if (!form || !feldNr || !feldMail || !ergebnis) return;

  var ENDPUNKT = wurzel.getAttribute('data-endpunkt') || '/apps/sendung/v1/suche';
  var VORSCHAU_AN = wurzel.getAttribute('data-vorschau') === '1';
  var HILFE = wurzel.getAttribute('data-hilfe') || '/pages/faq';
  var KNOPF_TEXT = knopfText ? knopfText.textContent : 'Sendung anzeigen';

  /* ---------- Texte ---------- */

  var FEHLERTEXT = {
    eingabe: 'Bitte trag die Bestellnummer und deine E-Mail-Adresse ein.',
    signatur: 'Die Abfrage ist gerade nicht erreichbar. Versuch es in ein paar Minuten noch einmal.',
    nicht_gefunden: 'Diese Kombination passt nicht zusammen. Prüfe Bestellnummer und E-Mail aus der Bestellbestätigung.',
    zu_viele: 'Zu viele Versuche hintereinander. Warte einen Moment und probier es dann noch einmal.',
    stoerung: 'Die Abfrage ist gerade nicht erreichbar. Versuch es in ein paar Minuten noch einmal.'
  };

  var STATUS = {
    offen: { wort: 'Bestellung eingegangen', symbol: 'paket', farbe: 'fg' },
    unbekannt: { wort: 'Noch kein Status', symbol: 'paket', farbe: 'fg' },
    angemeldet: { wort: 'Versand vorbereitet', symbol: 'paket', farbe: 'fg' },
    abholung: { wort: 'Liegt zur Abholung bereit', symbol: 'paket', farbe: 'tief' },
    // "versandt" ist die einzige belegbare Aussage, wenn der Dienstleister
    // uns nach der Uebergabe nichts mehr meldet. Dieser Zustand bekommt
    // KEINE Fortschrittsschiene, siehe schieneZeigen().
    versandt: { wort: 'Versandt', symbol: 'paket', farbe: 'fg' },
    unterwegs: { wort: 'Unterwegs', symbol: 'lkw', farbe: 'tief' },
    zustellung: { wort: 'In Zustellung', symbol: 'haus', farbe: 'tief' },
    zugestellt: { wort: 'Zugestellt', symbol: 'haken', farbe: 'tief' },
    problem: { wort: 'Zustellung hat nicht geklappt', symbol: 'warnung', farbe: 'warn' }
  };

  var FARBE = {
    fg: 'var(--ns-ink, #1a1d1a)',
    tief: 'var(--ns-accent-deep, #566b4c)',
    warn: 'var(--sv-warn, #b3261e)'
  };

  var STUFEN = [
    { lab: 'Bestellt', symbol: 'paket' },
    { lab: 'Verpackt', symbol: 'etikett' },
    { lab: 'Unterwegs', symbol: 'lkw' },
    { lab: 'Zugestellt', symbol: 'haken' }
  ];

  // Der Datenvertrag kennt FUENF Stufen (0 bis 4), die Schiene zeigt VIER
  // Punkte. Ohne Umrechnung verrutscht die Zuordnung um eins: bei stufe 2
  // stand oben "Unterwegs" und in der Schiene leuchtete "Verpackt".
  // Gemessen am 13.08.2026 an ?ns_sendung=unterwegs.
  //
  //   stufe 0 Bestellung eingegangen -> Punkt 1 Bestellt
  //   stufe 1 Versand vorbereitet    -> Punkt 2 Verpackt
  //   stufe 2 Unterwegs              -> Punkt 3 Unterwegs
  //   stufe 3 In Zustellung          -> Punkt 3 Unterwegs (Verfeinerung,
  //                                     sie steht im Statuswort)
  //   stufe 4 Zugestellt             -> Punkt 4 Zugestellt
  var PUNKT_JE_STUFE = [1, 2, 3, 3, 4];

  function punktNr(stufe) {
    var s = Math.max(0, Math.min(4, Number(stufe) || 0));
    return PUNKT_JE_STUFE[s];
  }

  var MONAT = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
  var MONAT_LANG = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var WOTAG = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var LAND = { DE: 'Deutschland', AT: 'Österreich', CH: 'Schweiz', NL: 'Niederlande', BE: 'Belgien', LU: 'Luxemburg', FR: 'Frankreich', IT: 'Italien', PL: 'Polen', DK: 'Dänemark' };

  /* ---------- Kleine Helfer ---------- */

  // Auf der internen Domain haengt Shopify sonst eine Umleitung davor.
  function pfad(p) {
    if (!/\.myshopify\.com$/.test(location.hostname)) return p;
    return p + (p.indexOf('?') >= 0 ? '&' : '?') + '_fd=0';
  }

  function esc(text) {
    return String(text == null ? '' : text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Nur gewoehnliche Web-Adressen. Alles andere faellt weg, statt es
  // ungeprueft in ein href zu schreiben.
  function sichereUrl(u) {
    if (!u) return null;
    return /^https?:\/\//i.test(String(u)) ? String(u) : null;
  }

  function sym(name, klasse) {
    return '<svg class="' + (klasse || '') + '" aria-hidden="true" focusable="false"><use href="#sv-' + name + '"></use></svg>';
  }

  function zwei(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function alsDatum(wert) {
    if (!wert) return null;
    var d = new Date(wert);
    return isNaN(d.getTime()) ? null : d;
  }

  function uhrzeit(d) {
    return zwei(d.getHours()) + ':' + zwei(d.getMinutes());
  }

  function tagesSchluessel(d) {
    return d.getFullYear() + '-' + zwei(d.getMonth() + 1) + '-' + zwei(d.getDate());
  }

  function tagesKopf(d) {
    var heute = new Date();
    if (tagesSchluessel(d) === tagesSchluessel(heute)) return 'Heute';
    var gestern = new Date(heute.getTime() - 86400000);
    if (tagesSchluessel(d) === tagesSchluessel(gestern)) return 'Gestern';
    return WOTAG[d.getDay()] + ', ' + d.getDate() + '. ' + MONAT[d.getMonth()];
  }

  function kurzDatum(d) {
    return WOTAG[d.getDay()] + ', ' + d.getDate() + '. ' + MONAT[d.getMonth()];
  }

  function langDatum(d) {
    return d.getDate() + '. ' + MONAT_LANG[d.getMonth()] + ' ' + d.getFullYear();
  }

  function landName(code) {
    if (!code) return '';
    return LAND[code] || code;
  }

  /* ---------- Aufbau des Ergebnisses ---------- */

  function statusKarte(paket, bestellung) {
    var info = STATUS[paket.status] || STATUS.unbekannt;
    var aufgegeben = alsDatum(bestellung.aufgegeben);
    var meta = 'Bestellung ' + esc(bestellung.nummer);
    if (aufgegeben) meta += ' · aufgegeben am ' + esc(langDatum(aufgegeben));

    var eta = '';
    var voraus = alsDatum(paket.voraussichtlich);
    var zugestellt = alsDatum(paket.zugestellt);
    if (zugestellt) {
      eta =
        '<div class="ns-sv__eta"><span class="ns-sv__eta-lab">Zugestellt am</span>' +
        '<span class="ns-sv__eta-wert">' + esc(kurzDatum(zugestellt)) + '</span></div>';
    } else if (voraus) {
      eta =
        '<div class="ns-sv__eta"><span class="ns-sv__eta-lab">Voraussichtlich</span>' +
        '<span class="ns-sv__eta-wert">' + esc(kurzDatum(voraus)) + '</span></div>';
    }

    return (
      '<div class="ns-sv__status" style="--sv-status: ' + FARBE[info.farbe] + '">' +
      '<div><div class="ns-sv__statuskopf">' +
      '<span class="ns-sv__statusic">' + sym(info.symbol) + '</span>' +
      '<p class="ns-sv__statuswort">' + esc(info.wort) + '</p></div>' +
      '<p class="ns-sv__statusmeta">' + meta + '</p></div>' +
      eta +
      '</div>'
    );
  }

  function schiene(paket) {
    var teile = [];
    // Bei Stufe 0 ist noch nichts beim Dienstleister, die Bestellung liegt
    // aber vor. Punkt 1 ist damit der aktuelle, die Fuellung bleibt
    // trotzdem auf 0. Ohne diesen Anker haette die Schiene keine
    // aktuelle Stufe und die Vorlesehilfe nichts zu melden.
    var aktivNr = punktNr(paket.stufe);
    for (var i = 0; i < 4; i++) {
      var nr = i + 1;
      var klasse = 'ns-sv__stufe';
      var symbolName = STUFEN[i].symbol;
      var versteckt = '';
      if (nr < aktivNr) {
        klasse += ' ns-sv__stufe--fertig';
        symbolName = 'haken';
        versteckt = '<span class="visually-hidden">erledigt</span>';
      } else if (nr === aktivNr) {
        klasse += ' ns-sv__stufe--aktiv';
        if (paket.status === 'problem') klasse += ' ns-sv__stufe--warn';
      }
      teile.push(
        '<li class="' + klasse + '"' + (nr === aktivNr ? ' aria-current="step"' : '') + '>' +
        '<span class="ns-sv__punkt">' + sym(symbolName) + '</span>' +
        '<span class="ns-sv__stufe-lab">' + esc(STUFEN[i].lab) + versteckt + '</span>' +
        '</li>'
      );
    }
    return '<ol class="ns-sv__schiene">' + teile.join('') + '</ol>';
  }

  function stationZeile(e, neu) {
    var d = alsDatum(e.zeit);
    return (
      '<div class="ns-sv__station' + (neu ? ' ns-sv__station--neu' : '') + '">' +
      '<span class="ns-sv__stationpunkt" aria-hidden="true"></span>' +
      '<span class="ns-sv__zeit">' + (d ? esc(uhrzeit(d)) : '') + '</span>' +
      '<span class="ns-sv__stationtext">' + esc(e.text) +
      (e.ort ? '<span class="ns-sv__ort">' + esc(e.ort) + '</span>' : '') +
      '</span></div>'
    );
  }

  // Nach Tagen gruppiert, neueste zuerst. Ab dem fuenften Eintrag geht es
  // in den einzigen Aufklapper der Seite.
  function stationenListe(ereignisse, ersterIstNeu) {
    var html = '';
    var letzterTag = '';
    for (var i = 0; i < ereignisse.length; i++) {
      var e = ereignisse[i];
      var d = alsDatum(e.zeit);
      var kopf = d ? tagesKopf(d) : '';
      if (kopf && kopf !== letzterTag) {
        html += '<p class="ns-sv__tag">' + esc(kopf) + '</p>';
        letzterTag = kopf;
      }
      html += stationZeile(e, !!ersterIstNeu && i === 0);
    }
    return html;
  }

  // Ohne belastbare Stationen gibt es keine Schiene. Jeder Punkt darauf
  // waere eine Vermutung, und eine Vermutung, die vier Wochen alt ist,
  // liest sich wie eine Zusage. Gemessen am 13.08.2026 an #261444.
  function schieneZeigen(paket) {
    return paket.status !== 'versandt';
  }

  function stationen(paket) {
    if (!paket.stationenVollstaendig) {
      // Das aelteste Ereignis ist die Uebergabe an den Dienstleister,
      // das ist die einzige Tatsache, die hier belegt ist.
      var uebergabe = null;
      var liste = paket.ereignisse || [];
      for (var i = liste.length - 1; i >= 0; i--) {
        if (/übergeben|uebergeben|versand/i.test(liste[i].text)) { uebergabe = alsDatum(liste[i].zeit); break; }
      }
      if (!uebergabe && liste.length) uebergabe = alsDatum(liste[0].zeit);

      // Bei einer alten Sendung ist das blosse Uebergabedatum zu duenn.
      // Die Zeitspanne ist eine Tatsache, keine Vermutung, und sie sagt
      // dem Kunden, woran er ist: laengst da oder nachfragen.
      var tage = uebergabe ? Math.floor((Date.now() - uebergabe.getTime()) / 86400000) : 0;
      var zusatz =
        tage >= 14
          ? 'Das ist ' + esc(tage) + ' Tage her, das Paket sollte längst bei dir sein. Falls nicht, schreib uns kurz, wir gehen dem nach.'
          : 'Weitere Angaben liegen uns für diese Sendung nicht vor. Wenn dein Paket nicht ankommt, schreib uns kurz, wir gehen dem nach.';

      return (
        '<div class="ns-sv__ohne">' +
        '<span class="ns-sv__ohne-t">' +
        (uebergabe
          ? 'Am ' + esc(langDatum(uebergabe)) + ' an den Versanddienstleister übergeben.'
          : 'An den Versanddienstleister übergeben.') +
        '</span>' +
        '<p>' + zusatz + '</p>' +
        '</div>'
      );
    }

    var liste = paket.ereignisse || [];
    if (!liste.length) return '';

    var sichtbar = stationenListe(liste.slice(0, 4), true);
    var rest = '';
    if (liste.length > 4) {
      rest =
        '<details class="ns-sv__mehr"><summary><span class="ns-sv__pfeil" aria-hidden="true"></span>' +
        'Alle Stationen anzeigen</summary><div class="ns-sv__stationen">' +
        stationenListe(liste.slice(4), false) +
        '</div></details>';
    }
    return '<div class="ns-sv__stationen">' + sichtbar + '</div>' + rest;
  }

  function inhalt(paket, bestellung) {
    var indizes = paket && paket.artikelIndex && paket.artikelIndex.length
      ? paket.artikelIndex
      : bestellung.artikel.map(function (_, i) { return i; });

    var zeilen = [];
    for (var i = 0; i < indizes.length; i++) {
      var a = bestellung.artikel[indizes[i]];
      if (!a) continue;
      var bild = sichereUrl(a.bild);
      zeilen.push(
        '<li class="ns-sv__zeile">' +
        (bild
          ? '<img class="ns-sv__bild" src="' + esc(bild) + '" alt="' + esc(a.titel) + '" width="56" height="56" loading="lazy" decoding="async">'
          : '<span class="ns-sv__bild-leer" aria-hidden="true">' + sym('paket') + '</span>') +
        '<span><span class="ns-sv__artikel-t">' + esc(a.titel) + '</span>' +
        (a.variante ? '<span class="ns-sv__artikel-v">' + esc(a.variante) + '</span>' : '') +
        '</span>' +
        '<span class="ns-sv__menge">× ' + esc(a.menge) + '</span>' +
        '</li>'
      );
    }
    return zeilen.length ? '<ul class="ns-sv__inhalt">' + zeilen.join('') + '</ul>' : '';
  }

  function notiz(paket) {
    if (!paket) {
      return (
        '<p class="ns-sv__notiz"><span class="ns-sv__notiz-t">Bestellung eingegangen</span>' +
        'Dein Paket geht innerhalb von 24 bis 48 Stunden raus. Sobald es unterwegs ist, bekommst du den Link automatisch per Mail.</p>'
      );
    }
    if (paket.status === 'zugestellt') {
      return (
        '<p class="ns-sv__notiz"><span class="ns-sv__notiz-t">Angekommen.</span>' +
        'Das Leder ist fabrikneu und sitzt am Anfang fest. Nach ein bis zwei Wochen Tragen weitet es sich und passt sich an. Bei dicken Handyhüllen ist es anfangs stramm.</p>'
      );
    }
    if (paket.status === 'problem') {
      return (
        '<p class="ns-sv__notiz"><span class="ns-sv__notiz-t">Zustellung hat nicht geklappt</span>' +
        'Der Versanddienstleister hat es nicht geschafft. In der Regel folgt ein zweiter Versuch am nächsten Werktag. Steht unten ein anderer Hinweis, gilt der.</p>'
      );
    }
    return '';
  }

  // KEIN Weg zu einer Seite des Dienstleisters. Vorgabe des Haendlers vom
  // 13.08.2026: der Kunde soll den Status hier sehen und nirgends sonst.
  // Frueher stand hier ein Knopf "Bei DHL nachsehen" beziehungsweise
  // "Sendung beim Dienstleister ansehen". Der Worker liefert die Adresse
  // deshalb gar nicht mehr aus (normalisieren.js setzt url auf null).
  // 20.08.2026: Knopf "Bewertung schreiben" raus. Nach der Zustellung bleibt
  // nur der Weg zur Hilfe.
  function aktionen(paket) {
    var teile = [];
    teile.push('<a class="ns-sv__link" href="' + esc(HILFE) + '">Fragen zur Lieferung</a>');
    return '<div class="ns-sv__aktionen">' + teile.join('') + '</div>';
  }

  function nummerChip(paket) {
    if (!paket.nummer) return '';
    // "Versanddienstleister" ist kein Name, sondern der Platzhalter fuer
    // "wir wissen nicht welcher". Zusammen mit einer 18-stelligen Nummer
    // sprengt er die Zeile und schiebt den Kopierknopf darunter. Dann
    // lieber nur die Nummer.
    var name = paket.dienstleister || '';
    var lab = name && name !== 'Versanddienstleister'
      ? '<span class="ns-sv__chip-lab">' + esc(name) + '</span>'
      : '';
    return (
      '<div class="ns-sv__nr">' +
      '<span class="ns-sv__chip">' + lab +
      '<span class="ns-sv__chip-nr">' + esc(paket.nummer) + '</span></span>' +
      '<button type="button" class="ns-sv__kopieren" data-nr="' + esc(paket.nummer) + '">' +
      sym('kopieren') + '<span class="ns-sv__kopieren-text">Kopieren</span></button>' +
      '</div>'
    );
  }

  function zielZeile(bestellung) {
    if (!bestellung.ziel || !bestellung.ziel.ort) return '';
    var land = landName(bestellung.ziel.land);
    return '<p class="ns-sv__ziel">Zustellung nach ' + esc(bestellung.ziel.ort) + (land ? ', ' + esc(land) : '') + '</p>';
  }

  function bauen(daten) {
    var b = daten.bestellung;
    var teile = [];

    if (!daten.pakete.length) {
      // Zustand 4: gefunden, noch nicht versandt.
      teile.push(
        '<article class="ns-sv__paket" data-stufe="0" data-status="offen">' +
        statusKarte({ status: 'offen', stufe: 0, voraussichtlich: null, zugestellt: null }, b) +
        schiene({ stufe: 0, status: 'offen' }) +
        notiz(null) +
        inhalt(null, b) +
        zielZeile(b) +
        aktionen(null) +
        '</article>'
      );
    } else {
      for (var i = 0; i < daten.pakete.length; i++) {
        var p = daten.pakete[i];
        teile.push(
          '<article class="ns-sv__paket" data-stufe="' + esc(p.stufe) + '" data-status="' + esc(p.status) + '">' +
          (daten.pakete.length > 1
            ? '<p class="ns-sv__paketkopf">Paket ' + (i + 1) + ' von ' + daten.pakete.length + '</p>'
            : '') +
          statusKarte(p, b) +
          notiz(p) +
          nummerChip(p) +
          (schieneZeigen(p) ? schiene(p) : '') +
          stationen(p) +
          inhalt(p, b) +
          zielZeile(b) +
          aktionen(p) +
          '</article>'
        );
      }
    }
    return teile.join('');
  }

  /* ---------- Anzeigen ---------- */

  function fuellungSetzen() {
    var artikel = ergebnis.querySelectorAll('.ns-sv__paket');
    for (var i = 0; i < artikel.length; i++) {
      var stufe = Number(artikel[i].getAttribute('data-stufe') || 0);
      // Die Fuellung folgt dem PUNKT, nicht der Stufe. Sonst zeigt die
      // Linie einen anderen Fortschritt als der hervorgehobene Punkt.
      var wert = Math.max(0, Math.min(100, ((punktNr(stufe) - 1) / 3) * 100));
      var bahn = artikel[i].querySelector('.ns-sv__schiene');
      if (bahn) bahn.style.setProperty('--sv-fuell', String(Math.round(wert * 10) / 10));
      artikel[i].classList.add('ns-sv--da');
    }
  }

  function zeigen(daten) {
    ergebnis.innerHTML = bauen(daten);
    ergebnis.hidden = false;
    wurzel.classList.add('ns-sv--treffer');
    spur.zustand = daten.pakete.length ? daten.pakete[0].status : 'offen';
    log('ergebnis ' + spur.zustand + ' pakete=' + daten.pakete.length);

    // Erst im naechsten Bildaufbau, damit die Linie sichtbar waechst,
    // statt fertig dazustehen.
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(fuellungSetzen);
      });
    } else {
      fuellungSetzen();
    }

    if (ergebnis.focus) ergebnis.focus();
    if (melder) melder.textContent = 'Ergebnis geladen.';
  }

  function fehlerZeigen(grund) {
    if (!fehlerZeile) return;
    fehlerZeile.textContent = FEHLERTEXT[grund] || FEHLERTEXT.stoerung;
    fehlerZeile.hidden = false;
    spur.zustand = 'fehler:' + grund;
    log('fehler ' + grund);
  }

  function fehlerWeg() {
    if (fehlerZeile) {
      fehlerZeile.hidden = true;
      fehlerZeile.textContent = '';
    }
    var felder = wurzel.querySelectorAll('.ns-sv__feld');
    for (var i = 0; i < felder.length; i++) felder[i].classList.remove('ns-sv__feld--fehler');
  }

  function laden(an) {
    if (skelett) skelett.hidden = !an;
    if (knopf) {
      if (an) knopf.setAttribute('aria-disabled', 'true');
      else knopf.removeAttribute('aria-disabled');
    }
    if (knopfText) knopfText.textContent = an ? 'Wird gesucht…' : KNOPF_TEXT;
  }

  function messen(art) {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
    // Nur das Ergebnis, nie die Eingaben. GTM kommt vom Stape-Embed.
    window.dataLayer.push({ event: 'sendung_abfrage', ergebnis: art });
  }

  /* ---------- Abfrage ---------- */

  var laeuft = false;

  function abfragen(nr, mail, token) {
    if (laeuft) return;
    laeuft = true;
    fehlerWeg();
    ergebnis.hidden = true;
    ergebnis.innerHTML = '';
    wurzel.classList.remove('ns-sv--treffer');
    laden(true);

    var adresse = ENDPUNKT + '?nr=' + encodeURIComponent(nr);
    if (token) adresse += '&t=' + encodeURIComponent(token);
    else adresse += '&mail=' + encodeURIComponent(mail);
    log('abfrage nr=' + nr + (token ? ' (token)' : ''));

    fetch(pfad(adresse), { headers: { Accept: 'application/json' }, credentials: 'omit' })
      .then(function (r) {
        return r.text().then(function (t) {
          var d = null;
          try { d = JSON.parse(t); } catch (e) { d = null; }
          return { http: r.status, daten: d };
        });
      })
      .then(function (a) {
        if (a.daten && a.daten.ok === true) {
          zeigen(a.daten);
          messen('treffer');
          // Die Bestellnummer darf in die Adresszeile, die E-Mail nie.
          if (window.history && history.replaceState) {
            history.replaceState(null, '', location.pathname + '?nr=' + encodeURIComponent(nr));
          }
          return;
        }
        var grund = a.daten && a.daten.grund ? a.daten.grund : 'stoerung';
        fehlerZeigen(grund);
        messen(grund);
      })
      .catch(function (err) {
        log('netzfehler ' + String(err).slice(0, 60));
        fehlerZeigen('stoerung');
        messen('stoerung');
      })
      .finally(function () {
        laeuft = false;
        laden(false);
      });
  }

  function feldMarkieren(feld) {
    var kasten = feld.closest ? feld.closest('.ns-sv__feld') : null;
    if (kasten) kasten.classList.add('ns-sv__feld--fehler');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (laeuft) return;
    fehlerWeg();

    var nr = (feldNr.value || '').trim().replace(/^#/, '');
    var mail = (feldMail.value || '').trim();

    if (!/^\d{3,12}$/.test(nr)) {
      feldMarkieren(feldNr);
      fehlerZeigen('eingabe');
      feldNr.focus();
      return;
    }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(mail)) {
      feldMarkieren(feldMail);
      fehlerZeigen('eingabe');
      feldMail.focus();
      return;
    }
    abfragen(nr, mail, null);
  });

  /* ---------- Kopierknopf ---------- */

  wurzel.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.ns-sv__kopieren') : null;
    if (!btn) return;
    var nummer = btn.getAttribute('data-nr') || '';
    var beschriftung = btn.querySelector('.ns-sv__kopieren-text');

    function geschafft() {
      if (beschriftung) beschriftung.textContent = 'Kopiert';
      if (melder) melder.textContent = 'Sendungsnummer kopiert.';
      setTimeout(function () {
        if (beschriftung) beschriftung.textContent = 'Kopieren';
      }, 2000);
    }

    // Drei Stufen, weil navigator.clipboard fehlen oder verweigert werden
    // kann: manche Browser geben sie nur her, wenn das Fenster im
    // Vordergrund steht. Gemessen am 13.08.2026, dabei fiel auf, dass
    // blosses Markieren als letzte Stufe zu wenig ist.
    //   1. navigator.clipboard
    //   2. execCommand ueber ein kurzlebiges Feld
    //   3. die Nummer markieren, Knopf ausblenden
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(nummer).then(geschafft).catch(function () {
        if (ersatzKopieren(nummer)) geschafft();
        else markieren(btn);
      });
    } else if (ersatzKopieren(nummer)) {
      geschafft();
    } else {
      markieren(btn);
    }
  });

  function ersatzKopieren(nummer) {
    if (!document.execCommand) return false;
    var feld = document.createElement('textarea');
    feld.value = nummer;
    feld.setAttribute('readonly', '');
    feld.setAttribute('aria-hidden', 'true');
    feld.style.position = 'fixed';
    feld.style.top = '-1000px';
    feld.style.opacity = '0';
    document.body.appendChild(feld);
    feld.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }
    document.body.removeChild(feld);
    return ok;
  }

  function markieren(btn) {
    var chip = btn.parentNode.querySelector('.ns-sv__chip-nr');
    if (chip && window.getSelection && document.createRange) {
      var r = document.createRange();
      r.selectNodeContents(chip);
      var s = window.getSelection();
      s.removeAllRanges();
      s.addRange(r);
      if (melder) melder.textContent = 'Sendungsnummer markiert.';
    }
    btn.hidden = true;
  }

  /* ---------- Vorschau ---------- */

  /* VORSCHAU-ANFANG (erzeugt aus worker/test/fixtures/ von scripts/sync-vorschau.mjs, nicht von Hand aendern) */
  var VORSCHAU = {
    "angemeldet": {
      "ok": true,
      "stand": "2026-08-13T08:02:11Z",
      "quelleGesamt": "dhl",
      "bestellung": {
        "nummer": "#261448",
        "aufgegeben": "2026-08-12T18:41:00Z",
        "storniert": false,
        "ziel": {
          "ort": "Herne",
          "land": "DE"
        },
        "artikel": [
          {
            "titel": "Nordstealth Body-Sling",
            "variante": "Schwarz",
            "menge": 1,
            "bild": "https://cdn.shopify.com/s/files/1/1047/7194/4787/files/48848_160x.webp?v=1785276858"
          }
        ]
      },
      "pakete": [
        {
          "stufe": 1,
          "status": "angemeldet",
          "dienstleister": "DHL",
          "nummer": "00340434161094042557",
          "url": null,
          "quelle": "dhl",
          "stationenVollstaendig": true,
          "voraussichtlich": null,
          "zugestellt": null,
          "artikelIndex": [
            0
          ],
          "ereignisse": [
            {
              "zeit": "2026-08-13T07:12:00+02:00",
              "text": "Die Auftragsdaten zu dieser Sendung wurden elektronisch an DHL übermittelt",
              "ort": null
            }
          ]
        }
      ]
    },
    "keine-stationen": {
      "ok": true,
      "stand": "2026-08-13T08:02:11Z",
      "quelleGesamt": "shopify",
      "bestellung": {
        "nummer": "#261444",
        "aufgegeben": "2026-07-10T15:48:00Z",
        "storniert": false,
        "ziel": {
          "ort": "Wolfsburg",
          "land": "DE"
        },
        "artikel": [
          {
            "titel": "Nordstealth Body-Sling",
            "variante": "Schwarz",
            "menge": 1,
            "bild": null
          }
        ]
      },
      "pakete": [
        {
          "stufe": 2,
          "status": "versandt",
          "dienstleister": "Versanddienstleister",
          "nummer": "YT2619400100171694",
          "url": null,
          "quelle": "shopify",
          "stationenVollstaendig": false,
          "voraussichtlich": null,
          "zugestellt": null,
          "artikelIndex": [
            0
          ],
          "ereignisse": [
            {
              "zeit": "2026-07-11T09:24:00+02:00",
              "text": "Sendung an den Versanddienstleister übergeben",
              "ort": null
            },
            {
              "zeit": "2026-07-10T15:48:00+02:00",
              "text": "Bestellung eingegangen",
              "ort": null
            }
          ]
        }
      ]
    },
    "nicht-versandt": {
      "ok": true,
      "stand": "2026-08-13T08:02:11Z",
      "quelleGesamt": "shopify",
      "bestellung": {
        "nummer": "#261447",
        "aufgegeben": "2026-08-12T20:37:00Z",
        "storniert": false,
        "ziel": {
          "ort": "Worpswede",
          "land": "DE"
        },
        "artikel": [
          {
            "titel": "Nordstealth Body-Sling",
            "variante": "Schwarz",
            "menge": 1,
            "bild": "https://cdn.shopify.com/s/files/1/1047/7194/4787/files/48848_160x.webp?v=1785276858"
          }
        ]
      },
      "pakete": []
    },
    "problem": {
      "ok": true,
      "stand": "2026-08-13T08:02:11Z",
      "quelleGesamt": "dhl",
      "bestellung": {
        "nummer": "#261439",
        "aufgegeben": "2026-08-07T12:55:00Z",
        "storniert": false,
        "ziel": {
          "ort": "Dormagen",
          "land": "DE"
        },
        "artikel": [
          {
            "titel": "Nordstealth Body-Sling",
            "variante": "Schwarz",
            "menge": 1,
            "bild": "https://cdn.shopify.com/s/files/1/1047/7194/4787/files/48848_160x.webp?v=1785276858"
          }
        ]
      },
      "pakete": [
        {
          "stufe": 2,
          "status": "problem",
          "dienstleister": "DHL",
          "nummer": "00340434161094033445",
          "url": null,
          "quelle": "dhl",
          "stationenVollstaendig": true,
          "voraussichtlich": null,
          "zugestellt": null,
          "artikelIndex": [
            0
          ],
          "ereignisse": [
            {
              "zeit": "2026-08-13T11:04:00+02:00",
              "text": "Die Sendung konnte nicht zugestellt werden, ein zweiter Zustellversuch ist vorgesehen",
              "ort": "Dormagen"
            },
            {
              "zeit": "2026-08-13T06:52:00+02:00",
              "text": "Die Sendung wurde im Ziel-Paketzentrum bearbeitet",
              "ort": "Neuss"
            },
            {
              "zeit": "2026-08-12T19:44:00+02:00",
              "text": "Die Sendung wurde im Start-Paketzentrum bearbeitet",
              "ort": "Hamburg"
            },
            {
              "zeit": "2026-08-12T09:58:00+02:00",
              "text": "Die Sendung wurde vom Absender in der Filiale eingeliefert",
              "ort": "Hamburg"
            }
          ]
        }
      ]
    },
    "stoerung": {
      "ok": false,
      "grund": "stoerung"
    },
    "unterwegs": {
      "ok": true,
      "stand": "2026-08-13T08:02:11Z",
      "quelleGesamt": "dhl",
      "bestellung": {
        "nummer": "#261445",
        "aufgegeben": "2026-08-10T09:14:00Z",
        "storniert": false,
        "ziel": {
          "ort": "Wien",
          "land": "AT"
        },
        "artikel": [
          {
            "titel": "Nordstealth Body-Sling",
            "variante": "Schwarz",
            "menge": 1,
            "bild": "https://cdn.shopify.com/s/files/1/1047/7194/4787/files/48848_160x.webp?v=1785276858"
          }
        ]
      },
      "pakete": [
        {
          "stufe": 2,
          "status": "unterwegs",
          "dienstleister": "DHL",
          "nummer": "00340434161094042557",
          "url": null,
          "quelle": "dhl",
          "stationenVollstaendig": true,
          "voraussichtlich": "2026-08-14",
          "zugestellt": null,
          "artikelIndex": [
            0
          ],
          "ereignisse": [
            {
              "zeit": "2026-08-13T06:41:00+02:00",
              "text": "Die Sendung wurde im Zielland verarbeitet",
              "ort": "Wien"
            },
            {
              "zeit": "2026-08-12T22:18:00+02:00",
              "text": "Die Sendung wurde im Export-Paketzentrum bearbeitet",
              "ort": "Feldkirchen"
            },
            {
              "zeit": "2026-08-12T14:05:00+02:00",
              "text": "Die Sendung wurde im Start-Paketzentrum bearbeitet",
              "ort": "Hamburg"
            },
            {
              "zeit": "2026-08-12T09:37:00+02:00",
              "text": "Die Sendung wurde vom Absender in der Filiale eingeliefert",
              "ort": "Hamburg"
            },
            {
              "zeit": "2026-08-11T17:52:00+02:00",
              "text": "Die Sendung wurde abgeholt",
              "ort": "Hamburg"
            },
            {
              "zeit": "2026-08-11T08:20:00+02:00",
              "text": "Das Versandetikett wurde erstellt",
              "ort": null
            },
            {
              "zeit": "2026-08-10T11:14:00+02:00",
              "text": "Die Auftragsdaten zu dieser Sendung wurden elektronisch an DHL übermittelt",
              "ort": null
            }
          ]
        }
      ]
    },
    "zugestellt": {
      "ok": true,
      "stand": "2026-08-13T08:02:11Z",
      "quelleGesamt": "dhl",
      "bestellung": {
        "nummer": "#261441",
        "aufgegeben": "2026-08-08T16:20:00Z",
        "storniert": false,
        "ziel": {
          "ort": "Kaufbeuren",
          "land": "DE"
        },
        "artikel": [
          {
            "titel": "Nordstealth Body-Sling",
            "variante": "Hellbraun",
            "menge": 1,
            "bild": "https://cdn.shopify.com/s/files/1/1047/7194/4787/files/5581_160x.webp?v=1786143482"
          }
        ]
      },
      "pakete": [
        {
          "stufe": 4,
          "status": "zugestellt",
          "dienstleister": "DHL",
          "nummer": "00340434161094011223",
          "url": null,
          "quelle": "dhl",
          "stationenVollstaendig": true,
          "voraussichtlich": "2026-08-12",
          "zugestellt": "2026-08-12T13:26:00+02:00",
          "artikelIndex": [
            0
          ],
          "ereignisse": [
            {
              "zeit": "2026-08-12T13:26:00+02:00",
              "text": "Die Sendung wurde erfolgreich zugestellt",
              "ort": "Kaufbeuren"
            },
            {
              "zeit": "2026-08-12T07:41:00+02:00",
              "text": "Die Sendung wurde in das Zustellfahrzeug geladen",
              "ort": "Kaufbeuren"
            },
            {
              "zeit": "2026-08-12T04:55:00+02:00",
              "text": "Die Sendung wurde im Ziel-Paketzentrum bearbeitet",
              "ort": "Germering"
            },
            {
              "zeit": "2026-08-11T21:08:00+02:00",
              "text": "Die Sendung wurde im Start-Paketzentrum bearbeitet",
              "ort": "Hamburg"
            },
            {
              "zeit": "2026-08-11T11:33:00+02:00",
              "text": "Die Sendung wurde vom Absender in der Filiale eingeliefert",
              "ort": "Hamburg"
            },
            {
              "zeit": "2026-08-09T08:47:00+02:00",
              "text": "Die Auftragsdaten zu dieser Sendung wurden elektronisch an DHL übermittelt",
              "ort": null
            }
          ]
        }
      ]
    },
    "zustellung": {
      "ok": true,
      "stand": "2026-08-13T08:02:11Z",
      "quelleGesamt": "dhl",
      "bestellung": {
        "nummer": "#261446",
        "aufgegeben": "2026-08-10T07:02:00Z",
        "storniert": false,
        "ziel": {
          "ort": "Bonn",
          "land": "DE"
        },
        "artikel": [
          {
            "titel": "Nordstealth Body-Sling",
            "variante": "Braun",
            "menge": 1,
            "bild": "https://cdn.shopify.com/s/files/1/1047/7194/4787/files/884896_160x.webp?v=1785276858"
          }
        ]
      },
      "pakete": [
        {
          "stufe": 3,
          "status": "zustellung",
          "dienstleister": "DHL",
          "nummer": "00340434161094098765",
          "url": null,
          "quelle": "dhl",
          "stationenVollstaendig": true,
          "voraussichtlich": "2026-08-13",
          "zugestellt": null,
          "artikelIndex": [
            0
          ],
          "ereignisse": [
            {
              "zeit": "2026-08-13T07:48:00+02:00",
              "text": "Die Sendung wurde in das Zustellfahrzeug geladen und wird heute zugestellt",
              "ort": "Bonn"
            },
            {
              "zeit": "2026-08-13T05:02:00+02:00",
              "text": "Die Sendung wurde im Ziel-Paketzentrum bearbeitet",
              "ort": "Bonn"
            },
            {
              "zeit": "2026-08-12T20:31:00+02:00",
              "text": "Die Sendung wurde im Start-Paketzentrum bearbeitet",
              "ort": "Hamburg"
            },
            {
              "zeit": "2026-08-12T10:12:00+02:00",
              "text": "Die Sendung wurde vom Absender in der Filiale eingeliefert",
              "ort": "Hamburg"
            },
            {
              "zeit": "2026-08-11T09:05:00+02:00",
              "text": "Die Auftragsdaten zu dieser Sendung wurden elektronisch an DHL übermittelt",
              "ort": null
            }
          ]
        }
      ]
    },
    "zwei-pakete": {
      "ok": true,
      "stand": "2026-08-13T08:02:11Z",
      "quelleGesamt": "gemischt",
      "bestellung": {
        "nummer": "#261437",
        "aufgegeben": "2026-08-09T14:03:00Z",
        "storniert": false,
        "ziel": {
          "ort": "Wolfsburg",
          "land": "DE"
        },
        "artikel": [
          {
            "titel": "Nordstealth Body-Sling",
            "variante": "Schwarz",
            "menge": 1,
            "bild": "https://cdn.shopify.com/s/files/1/1047/7194/4787/files/48848_160x.webp?v=1785276858"
          },
          {
            "titel": "Nordstealth Body-Sling",
            "variante": "Braun",
            "menge": 2,
            "bild": "https://cdn.shopify.com/s/files/1/1047/7194/4787/files/884896_160x.webp?v=1785276858"
          }
        ]
      },
      "pakete": [
        {
          "stufe": 4,
          "status": "zugestellt",
          "dienstleister": "DHL",
          "nummer": "00340434161094055667",
          "url": null,
          "quelle": "dhl",
          "stationenVollstaendig": true,
          "voraussichtlich": "2026-08-12",
          "zugestellt": "2026-08-12T10:19:00+02:00",
          "artikelIndex": [
            0
          ],
          "ereignisse": [
            {
              "zeit": "2026-08-12T10:19:00+02:00",
              "text": "Die Sendung wurde erfolgreich zugestellt",
              "ort": "Wolfsburg"
            },
            {
              "zeit": "2026-08-12T06:33:00+02:00",
              "text": "Die Sendung wurde in das Zustellfahrzeug geladen",
              "ort": "Wolfsburg"
            },
            {
              "zeit": "2026-08-11T22:47:00+02:00",
              "text": "Die Sendung wurde im Ziel-Paketzentrum bearbeitet",
              "ort": "Braunschweig"
            },
            {
              "zeit": "2026-08-11T13:12:00+02:00",
              "text": "Die Sendung wurde vom Absender in der Filiale eingeliefert",
              "ort": "Hamburg"
            }
          ]
        },
        {
          "stufe": 2,
          "status": "unterwegs",
          "dienstleister": "DHL",
          "nummer": "00340434161094077889",
          "url": null,
          "quelle": "shopify",
          "stationenVollstaendig": true,
          "voraussichtlich": "2026-08-14",
          "zugestellt": null,
          "artikelIndex": [
            1
          ],
          "ereignisse": [
            {
              "zeit": "2026-08-13T05:26:00+02:00",
              "text": "Unterwegs zu dir",
              "ort": "Braunschweig"
            },
            {
              "zeit": "2026-08-12T18:09:00+02:00",
              "text": "Vom Versanddienstleister abgeholt",
              "ort": "Hamburg"
            },
            {
              "zeit": "2026-08-12T08:15:00+02:00",
              "text": "Versandetikett erstellt",
              "ort": null
            }
          ]
        }
      ]
    }
  };
  /* VORSCHAU-ENDE */

  // Die Vorschaudaten tragen feste Zeitstempel, damit sie mit den
  // Vertragstests uebereinstimmen. Fuer die Anzeige werden sie einmalig
  // so verschoben, dass das neueste Ereignis gerade eben war. Nur dann
  // laesst sich "Heute" und "Gestern" ueberhaupt ansehen. Die Datei
  // selbst bleibt unberuehrt.
  function vorschauZeitenSchieben(daten) {
    var neueste = 0;
    var i;
    for (i = 0; i < daten.pakete.length; i++) {
      var evs = daten.pakete[i].ereignisse || [];
      for (var j = 0; j < evs.length; j++) {
        var t = Date.parse(evs[j].zeit);
        if (!isNaN(t) && t > neueste) neueste = t;
      }
    }
    if (!neueste) return daten;
    var delta = Date.now() - neueste - 42 * 60000; // das Neueste liegt 42 Minuten zurueck

    function schieb(wert) {
      var t = Date.parse(wert);
      return isNaN(t) ? wert : new Date(t + delta).toISOString();
    }
    function schiebTag(wert) {
      if (!wert) return wert;
      var t = Date.parse(wert + 'T12:00:00Z');
      return isNaN(t) ? wert : new Date(t + delta).toISOString().slice(0, 10);
    }

    daten.stand = schieb(daten.stand);
    if (daten.bestellung.aufgegeben) daten.bestellung.aufgegeben = schieb(daten.bestellung.aufgegeben);
    for (i = 0; i < daten.pakete.length; i++) {
      var p = daten.pakete[i];
      if (p.zugestellt) p.zugestellt = schieb(p.zugestellt);
      p.voraussichtlich = schiebTag(p.voraussichtlich);
      for (var k = 0; k < (p.ereignisse || []).length; k++) {
        p.ereignisse[k].zeit = schieb(p.ereignisse[k].zeit);
      }
    }
    return daten;
  }

  function vorschauZeigen(name) {
    var roh = VORSCHAU[name];
    if (!roh) return false;
    var daten = JSON.parse(JSON.stringify(roh));
    log('vorschau ' + name);
    if (daten.ok === false) {
      fehlerZeigen(daten.grund || 'stoerung');
      return true;
    }
    zeigen(vorschauZeitenSchieben(daten));
    return true;
  }

  /* ---------- Beim Laden ---------- */

  function start() {
    var p = new URLSearchParams(location.search);

    if (VORSCHAU_AN) {
      var name = p.get('ns_sendung');
      if (name && vorschauZeigen(name)) return;
    }

    var nr = (p.get('nr') || '').trim().replace(/^#/, '');
    var token = (p.get('t') || '').trim();
    if (nr) {
      feldNr.value = nr;
      if (token) {
        // Ein-Klick-Link aus der Versandmail: ohne Tippen direkt zum Status.
        abfragen(nr, '', token);
        return;
      }
      feldMail.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
